import React, {useEffect, useState} from "react";
import countries from "../data/countries.json";
import {apiRequest, getUsers} from "../api"; // Import the apiRequest method

const UniversityModal = ({university, onClose, onSave}) => {
    const [name, setName] = useState("");
    const [contactEmail, setContactEmail] = useState("");
    const [country, setCountry] = useState("");
    const [selectedUser, setSelectedUser] = useState("");
    const [isLoading, setIsLoading] = useState(false); // Loading state
    const [feedbackMessage, setFeedbackMessage] = useState(null); // Feedback state
    const [users, setUsers] = useState([]); // State for user list

    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem("token"); // Retrieve token from local storage

    useEffect(() => {
        if (university) {
            setName(university.name);
            setContactEmail(university.contact_email);
            setCountry(university.country);
            setSelectedUser(university.contact_user);
            console.log(university)
        } else {
            setName("");
            setContactEmail("");
            setSelectedUser("");
            setCountry("");
        }
        fetchUsers()
        console.log(users)
    }, [university]);

    const fetchUsers = async () => {
        try {
            const users = await getUsers(); // Call API
            setUsers(users);
        } catch (error) {
            console.error("Error fetching users:", error);
            setUsers([]); // Default to empty array on error
        }

    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = {
            name,
            contact_email: contactEmail,
            contact_user: selectedUser,
            country,
        };

        const url = university
            ? `${apiUrl}/universities/${university.id}`
            : `${apiUrl}/universities`;
        const method = university ? "PUT" : "POST";

        setIsLoading(true);
        setFeedbackMessage(null); // Clear previous feedback

        try {
            const response = await apiRequest(url, method, payload, token);
            console.log(
                `University ${university ? "updated" : "created"} successfully:`,
                response
            );

            // Set success feedback message
            setFeedbackMessage(
                `University ${university ? "updated" : "created"} successfully!`
            );

            // Delay before closing the modal to allow the user to see the message
            setTimeout(() => {
                onSave();
                onClose();
            }, 2000); // 2-second delay
        } catch (error) {
            console.error(
                `Error ${university ? "updating" : "creating"} university:`,
                error
            );
            setFeedbackMessage(
                `Failed to ${university ? "update" : "create"} university. Please try again.`
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "5px",
                    width: "400px",
                }}
            >
                <h4>{university ? "Edit University" : "Add New University"}</h4>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>University Name:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                            disabled={isLoading}
                        />
                    </div>
                    <div className="form-group">
                        <label>Contact Email:</label>
                        <input
                            type="email"
                            className="form-control"
                            value={contactEmail}
                            onChange={(e) => setContactEmail(e.target.value)}
                            required
                            disabled={isLoading}
                        />
                    </div>
                    <div className="form-group">
                        <label>Designated User</label>
                        <select
                            className="form-control"
                            value={selectedUser}
                            onChange={(e) => setSelectedUser(e.target.value)}

                        >
                            <option value="" disabled>
                                Select a User
                            </option>

                            {users.map((user) => (
                                <option key={user.id} value={user.id}>
                                    {user.first_name} {user.last_name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Country:</label>
                        <select
                            className="form-control"
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                            required
                            disabled={isLoading}
                        >
                            <option value="" disabled>
                                -- Select a Country --
                            </option>
                            {countries.map((c) => (
                                <option key={c.name} value={c.name}>
                                    {c.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="modal-footer">
                        <button type="submit" className="btn btn-primary" disabled={isLoading}>
                            {isLoading ? (
                                <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                ></span>
                            ) : university ? "Update" : "Save"}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onClose}
                            disabled={isLoading}
                        >
                            Cancel
                        </button>
                    </div>
                    {feedbackMessage && (
                        <div
                            className={`alert mt-3 ${
                                feedbackMessage.includes("successfully")
                                    ? "alert-success"
                                    : "alert-danger"
                            }`}
                        >
                            {feedbackMessage}
                        </div>
                    )}
                </form>
            </div>
        </div>
    );
};

export default UniversityModal;
